import { HelixSearchLogStatusV2 } from '../../api/helixSearchV2/models/StartHelixSearchV2'
import HelixSearchV2InsightItem from './HelixSearchV2InsightItem'
import {
    HELIX_INSIGHT_SIZE_STYLES,
    HelixSearchV2InsightSize,
} from './HelixSearchV2InsightSizeStyles'
import { HelixSearchV2TopPickBadge } from './HelixSearchV2TopPickBadge'
import { formatAbbreviatedNumber } from '../../utils/numberUtils'

type Props = {
    inNetwork: number
    matchesBoth: number
    filteredCandidatePoolCount: number
    topPickCount?: number | null
    filteredTopPickCount?: number | null
    enabledLlmScoring?: boolean | null
    logStatus?: HelixSearchLogStatusV2 | null
    size?: HelixSearchV2InsightSize
}

const SHOW_TOP_PICK_STATUSES: HelixSearchLogStatusV2[] = [
    'GETTING_CONTXT_SCORE',
    'COMPLETE',
    'FAILED',
    'CANCELLING',
    'CANCELED',
]

export default function HelixSearchV2Insights({
    inNetwork,
    matchesBoth,
    filteredCandidatePoolCount,
    topPickCount = 0,
    filteredTopPickCount = 0,
    enabledLlmScoring = false,
    logStatus = null,
    size = 'default',
}: Props) {
    const llmScoringEnabledForRun = Boolean(enabledLlmScoring)
    const shouldShowTopPickCount =
        llmScoringEnabledForRun &&
        (logStatus ? SHOW_TOP_PICK_STATUSES.includes(logStatus) : true)
    const hiddenByFilters = Math.max(
        matchesBoth - filteredCandidatePoolCount,
        0,
    )
    const shouldShowHiddenByFilters = hiddenByFilters > 0
    const hiddenTopPicksByFilters = Math.max(
        (topPickCount ?? 0) - (filteredTopPickCount ?? 0),
        0,
    )
    const shouldShowTopPicksHiddenByFilters =
        shouldShowTopPickCount && hiddenTopPicksByFilters > 0

    return (
        <div className="flex gap-4 justify-center flex-wrap">
            <HelixSearchV2InsightItem
                label="Network Searched"
                value={inNetwork}
                size={size}
            />
            <HelixSearchV2InsightItem
                label="Candidates Found"
                value={matchesBoth}
                size={size}
                subtitle={
                    shouldShowHiddenByFilters
                        ? `(${formatAbbreviatedNumber(
                              hiddenByFilters,
                          )} hidden by filters)`
                        : undefined
                }
            />
            {llmScoringEnabledForRun && shouldShowTopPickCount && (
                <HelixSearchV2InsightItem
                    label={<HelixSearchV2TopPickBadge pluralized={true} />}
                    value={topPickCount ?? 0}
                    size={size}
                    subtitle={
                        shouldShowTopPicksHiddenByFilters
                            ? `(${formatAbbreviatedNumber(
                                  hiddenTopPicksByFilters,
                              )} hidden by filters)`
                            : undefined
                    }
                />
            )}
            {llmScoringEnabledForRun && !shouldShowTopPickCount && (
                <div
                    className={`${HELIX_INSIGHT_SIZE_STYLES[size].container} flex flex-col items-center justify-center border rounded-xl bg-white shadow text-center transition duration-300 hover:shadow-md overflow-hidden`}
                >
                    <div
                        className={`${HELIX_INSIGHT_SIZE_STYLES[size].label} text-gray-500 font-semibold truncate mb-1 px-2 leading-snug break-words whitespace-normal`}
                    >
                        <HelixSearchV2TopPickBadge pluralized={true} />
                    </div>
                    <div
                        className={`${HELIX_INSIGHT_SIZE_STYLES[size].value} font-mono font-bold text-gray-400`}
                    >
                        Pending...
                    </div>
                </div>
            )}
        </div>
    )
}
